module.exports = __webpack_public_path__ + "media/images/bagagerie-2009f5a45fe859d2e795730c12bb1ebc.svg";